const COUNTRY_LIST_SEPARATOR = ',';
const DEFAULT_ENDUSER_STATEMENT_COUNTRIES = ['TR', 'AE'] as const;

export const parseCountryCodeList = (
  countriesValue: string | null | undefined
): string[] => {
  if (countriesValue === null || countriesValue === undefined) {
    return [...DEFAULT_ENDUSER_STATEMENT_COUNTRIES];
  }

  if (countriesValue.trim() === '') {
    return [];
  }

  return countriesValue
    .split(COUNTRY_LIST_SEPARATOR)
    .map((countryCode) => countryCode.trim().toUpperCase())
    .filter((countryCode) => countryCode.length > 0);
};

export const requiresEndUserStatement = (
  countryCode: string | null | undefined,
  countriesValue: string | null | undefined
): boolean => {
  if (!countryCode) {
    return false;
  }

  const configuredCountries = parseCountryCodeList(countriesValue);
  if (!configuredCountries.length) {
    return false;
  }

  return configuredCountries.includes(countryCode.trim().toUpperCase());
};
